module.exports = __webpack_public_path__ + "static/media/logo-coloured.f4d075cc.svg";